import { render, staticRenderFns } from "./RobotSection.vue?vue&type=template&id=4ff2ad1a&scoped=true"
import script from "./RobotSection.vue?vue&type=script&lang=js"
export * from "./RobotSection.vue?vue&type=script&lang=js"
import style0 from "./RobotSection.vue?vue&type=style&index=0&id=4ff2ad1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff2ad1a",
  null
  
)

export default component.exports